import React from 'react';
import constants from 'Constants';
import _ from "lodash";

/**
 * Define React.Context wrapper to expose top-level variables to all children via useContext() hook.
 */
export const DataContext = React.createContext(null);
export const useDataContext = () => React.useContext(DataContext);

/**
 * Returns content div width of a QuestionBox based on `w-11/12` { width: 91.66667%; } property in Page component and
 * `p-8` { padding: 32px; } property in QuestionBox content div in pixels.
 */
export const getQuestionBoxContentWidth = () => {
    return (window.innerWidth * .92) - 64;
};

/**
 * Determines proper size for each individual rating icon by calculating QuestionBox content width minus gap size
 * between options, all divided by total number of choices. Caps max size at 50px.
 */
export const getRatingIconSize = (numChoices) => {
    return Math.min(((getQuestionBoxContentWidth() - (getRatingIconGap() * (numChoices - 1))) / numChoices), 50);
};

/**
 * Get gap size between rating icons in px.
 */
export const getRatingIconGap = () => {
    return window.innerWidth >= constants.screens.md ? 10 : 6;
};

/**
 * Check if app is being ran in iframe
 *
 * TODO Move this to an util file after we have more of these misc.
 * @returns {boolean}
 */
export const isInIframe = () => {
    return window.self !== window.top;
}

/**
 * Filter and reduce a URLSearchParam to a plain json with patient data.
 */
export const getPatientData = (searchParams) => {
    const allowedKeys = [
        'first_name',
        'last_name',
        'street',
        'city',
        'postal',
        'date_of_birth',
        'account_number',
        'language',
        'mrn',
    ];
    return Array.from(searchParams.keys())
        .filter(key => allowedKeys.includes(key))
        .reduce((obj, key) => {
            return {
                ...obj,
                [_.camelCase(key)]: searchParams.get(key)
            };
        }, {});
}
